@if (previewMode()) {
  <div class="preview-banner">
    <app-svg src="/assets/icons/globe-eye.svg" color="primary"></app-svg>
    <div>
      <b>Gallery Preview</b>
      <span>This is what people with the link will see.</span>
    </div>

    <a
      [href]="correctPicflowUrl + '/a/gallery/' + gallery()?.id"
      appButton
      name="edit"
      location="view-gallery-page"
      color="primary"
      shape="round"
      height="0"
      spacing="4"
      size="0-5"
    >
      Edit
    </a>

    <button
      appButton
      class="close-preview-button"
      name="close-preview"
      location="view-gallery-page"
      color="simple-gray"
      height="0"
      [iconButton]="true"
      shape="round"
      (click)="previewMode.set(false)"
    >
      <app-svg src="/assets/icons/cross.svg"> </app-svg>
    </button>
  </div>
}
